module.exports = __webpack_public_path__ + "img/lock.8d05b0d1.png";